import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { GepardModule } from './gepard/gepard.module';
import { SeasonModule } from './season/season.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from './app.service';
import { AppCommonsModule } from './app-commons/app-commons.module';

@NgModule({
  imports: [
    AppCommonsModule,
    RouterModule,
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    PopoverModule.forRoot(),
    GepardModule,
    SeasonModule,
    NgbModule
  ],
  exports: [
  ],
	declarations: [
		AppComponent,
		DashboardComponent
	],
  providers: [
    AppService,
    DecimalPipe,
    DatePipe
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}
